"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _appInformation = require("@/api/appManage/appInformation");
var _appendUser = _interopRequireDefault(require("./components/appendUser.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AppInformation',
  components: {
    appendUser: _appendUser.default
  },
  data: function data() {
    return {
      ruleForm: {
        name: '',
        shortCode: '',
        // appBaseUrl: '',
        uniAppId: '',
        uid: null,
        agent: '',
        inviteConfig: '',
        icon: '',
        defaultUser: {
          nickname: '',
          phone: '',
          status: 0
        }
      },
      rules: {
        name: [{
          required: true,
          message: '请输入APP名称',
          trigger: 'blur'
        }],
        shortCode: [{
          required: true,
          message: '请输入APP短码',
          trigger: 'blur'
        }, {
          pattern: /^[a-z\d]{1,2}$/,
          message: '最多两位纯小写英文字符或数字+英文字符',
          trigger: 'blur'
        }],
        // appBaseUrl: [
        //   { required: true, message: '请输入APP域名', trigger: 'blur' }
        // ],
        uniAppId: [{
          required: true,
          message: '请输入uni-app应用标识(AppId)',
          trigger: 'blur'
        }],
        agent: [{
          required: true,
          message: '请选择APP模式',
          trigger: 'change'
        }],
        inviteConfig: [{
          required: true,
          message: '请选择邀请码是否填写',
          trigger: 'change'
        }],
        icon: [{
          required: true,
          message: '请上传APP图标',
          trigger: 'change'
        }]
        // 'defaultUser.nickname': [
        //   { required: true, message: '请输入用户名', trigger: 'blur' }
        // ],
        // 'defaultUser.status': [
        //   { required: true, message: '请选择管理员状态', trigger: 'change' }
        // ],
        // 'defaultUser.phone': [
        //   { required: true, message: '请输入手机号', trigger: 'blur' },
        //   { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号', trigger: ['blur', 'change'] }
        // ]
      },
      drawer: false,
      direction: 'rtl',
      queryData: {
        nickName: '',
        phone: ''
      },
      tableData: [],
      dialogVisible: false
    };
  },
  methods: {
    handleRemove: function handleRemove(file, val) {
      // 处理文件删除逻辑
      this.ruleForm[val] = '';
    },
    // changeRadio(val) {
    //   this.ruleForm.type = val
    //   this.ruleForm.uid = null
    //   this.ruleForm.defaultUser = {
    //     nickname: '',
    //     phone: '',
    //     status: 0
    //   }
    // },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认此操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.addTenant();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, val) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.ruleForm[val] = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    onInitRuleForm: function onInitRuleForm() {
      this.ruleForm = {
        // userId: null,
        // name: '',
        // type: 0,
        // icon: '',
        // defaultUser: {
        //   nickname: '',
        //   phone: '',
        //   status: 0
        // }
        name: '',
        shortCode: '',
        // appBaseUrl: '',
        uniAppId: '',
        uid: null,
        agent: '',
        inviteConfig: '',
        icon: '',
        defaultUser: {
          nickname: '',
          phone: '',
          status: 0
        }
      };
    },
    addTenant: function () {
      var _addTenant2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context2.n = 1;
              return (0, _appInformation.addTenant)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.onInitRuleForm();
                this.$router.go(-1);
              }
              console.log('res');
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function addTenant() {
        return _addTenant2.apply(this, arguments);
      }
      return addTenant;
    }(),
    // 去选择
    onGoToUser: function onGoToUser() {
      this.drawer = true;
      this.queryUserPageWhileCreateApp();
    },
    onInquire: function onInquire() {
      this.queryUserPageWhileCreateApp();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        nickName: '',
        phone: ''
      };
      this.queryUserPageWhileCreateApp();
    },
    onSelect: function onSelect(row) {
      var _this2 = this;
      this.$confirm('确认选择该用户为APP默认管理员？').then(function (_) {
        _this2.drawer = false;
        _this2.ruleForm.defaultUser.nickname = row.nickName;
        _this2.ruleForm.defaultUser.phone = row.phone;
        _this2.ruleForm.uid = row.id;
      }).catch(function (_) {});
    },
    handleClose: function handleClose(done) {
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    queryUserPageWhileCreateApp: function () {
      var _queryUserPageWhileCreateApp2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context3.n = 1;
              return (0, _appInformation.queryUserPageWhileCreateApp)(params);
            case 1:
              res = _context3.v;
              console.log('res', res);
              this.tableData = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function queryUserPageWhileCreateApp() {
        return _queryUserPageWhileCreateApp2.apply(this, arguments);
      }
      return queryUserPageWhileCreateApp;
    }(),
    // 新增
    onAdd: function onAdd() {
      this.$refs.appendUser.open();
    },
    onAppendUser: function onAppendUser() {
      this.onInitialize();
    }
  }
};